module.exports = __webpack_public_path__ + "static/flags/JM-23e0ae2c1ed0770e92c59562cbe42fdb.gif";